import React, { useContext } from 'react';
import '../../dash.css'
import UserProvider from '../../context/UserContext';
import { useAlert } from "react-alert";

const CardRefresh = () => {
    const alert = useAlert();
    const Data = useContext(UserProvider.context);
    
    function alertSuccess(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.success(message)
        }
    }

    function alertError(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.error(message)
        }
    }
    
    function CloseCard(){
        var x = document.getElementById("refresh");
        if(x.style.display === "flex") {
            x.style.display = "none";
        }

        var y = document.getElementById("overlay");
        if(y.style.display === "flex") {
            y.style.display = "none";
        }
    }

    async function refreshKey() {
        if(document.getElementById('yes-button').disabled === false){
            document.getElementById('yes-button').disabled = true;
            const url = `${process.env.REACT_APP_API_URL}/refresh-key/`

            fetch(url, {
                credentials: "include",
                method: 'POST',
                })
                .then(function (response) {
                    if(response.status === 200){
                        alertSuccess("Key refreshed")
                        fetch(`${process.env.REACT_APP_API_URL}/basic-info/`, {
                            headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
                            credentials: 'include',
                            method: 'GET',
                        })
                        .then(function (response) {
                        if(response.status === 200){
                            response.json().then(function(data){
                            Data.setMember(data)
                            CloseCard()
                            document.getElementById('yes-button').disabled = false;
                            })
                        }
                        else{
                            console.log('Internal Server Error');
                            document.getElementById('yes-button').disabled = false;
                        }
                        })     
                        .catch(err => {
                            console.log('Internal Server Error');
                            document.getElementById('yes-button').disabled = false;
                        });
                    }
                    else{
                        document.getElementById('yes-button').disabled = false;
                        alertError("An error ocurred")
                    }
                })
                .catch(err => {
                    document.getElementById('yes-button').disabled = false;
                    alertError("An error ocurred")
                    console.log(err)
                });
            }
    }

    return(
        <div className="card-component mail-card">
            <div className="mail-card-content card-content-holder">
                <div>
                    <h4 className="card-title">Refresh key</h4>
                    <div className="close-button-holder">
                        <button className="close-button" onClick={CloseCard}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <div className="refresh-disclaimer">
                        <i className="fas fa-exclamation-circle"></i><h6 className="no-margin">Are you sure you want to refresh your key?<br></br>Your current key will be no longer valid.</h6>
                    </div>
                    <div className="refresh-key-buttons">
                        <div className="yes-no-holder">
                            <button id="yes-button" className="refresh-key-button pink-button" onClick={refreshKey}>
                                <h4>Yes</h4>
                            </button>
                            <button id="no-button" className="refresh-key-button" onClick={CloseCard}>
                                <h4>No</h4>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CardRefresh;